const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速爆料',
    description: '7×24小时全天候监控网络热点，第一时间为您推送最新爆料内容，让您永远快人一步掌握瓜料动态。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家信源',
    description: '拥有业内最可靠的独家信息渠道，多条内幕消息均由吃瓜51率先曝光，确保内容的独家性与真实性。',
  },
  {
    icon: 'ri-group-line',
    title: '万人吃瓜社区',
    description: '汇聚数百万吃瓜群众，热门事件评论区秒破万条。在这里，您可以与全国瓜友一起实时讨论最新爆料。',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50/60" aria-labelledby="feature-title">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-label font-medium text-foreground-400 uppercase tracking-widest mb-2">
            为什么选择我们
          </p>
          <h2 id="feature-title" className="font-heading font-black text-2xl md:text-4xl text-foreground-950 leading-tight max-w-2xl">
            吃瓜51 —— 您身边最可靠的
            <br />
            吃瓜情报平台
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl p-6 md:p-8 transition-all duration-300 hover:bg-background-100"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-3xl text-foreground-950`}></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}